import React, { useContext, useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet-routing-machine';
import { Button, Modal, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";

export default function CarteLeafletModal({ items, customIcon }) {
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const mapRef = useRef(null);
  const leafletMap = useRef(null);

  // Icône par défaut (marker classique)
  const defaultIcon = L.icon({
    iconUrl: process.env.PUBLIC_URL + "/images/location.png",
    iconSize: [38, 95],
    shadowSize: [50, 64],
    iconAnchor: [22, 94],
    shadowAnchor: [4, 62],
    popupAnchor: [-3, -76]
  });

  // Créer un divIcon personnalisé avec l'emoji
  const createEmojiIcon = () => {
    return L.divIcon({
      html: `<div style="
                font-size: 32px;
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: white;
                border-radius: 50%;
                box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                border: 3px solid #667eea;
            ">${customIcon}</div>`,
      className: '',
      iconSize: [40, 40],
      iconAnchor: [20, 20],
      popupAnchor: [0, -20]
    });
  };

  useEffect(() => {
    if (modalAddOpen && mapRef.current && !leafletMap.current) {
      // --- Définir les tuiles ---
      const openstreetmap = L.tileLayer(
        "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          maxZoom: 19,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }
      );

      const googleStreets = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );

      const googleHybrid = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );

      // --- Créer la carte ---
      const map = L.map(mapRef.current, {
        center: [7.3697, 12.3547],
        zoom: 6,
        layers: [openstreetmap], // par défaut OSM
      });

      // --- Control des couches ---
      const baseMaps = {
        "Open Street Map": openstreetmap,
        "Google Streets": googleStreets,
        "Google Map Hybrid": googleHybrid,
      };

      L.control.layers(baseMaps).addTo(map);

      leafletMap.current = map;

      // Force le redimensionnement après un court délai
      setTimeout(() => {
        map.invalidateSize();
      }, 100);

      // localiser l'utilisateur
      /* map.locate({ setView: true, maxZoom: 16 });
      map.on("locationfound", (e) => {
        L.circle(e.latlng, e.accuracy).addTo(map);
      }); */
    }
  }, [modalAddOpen]);

  // Ajout / mise à jour des markers quand items change
  useEffect(() => {
    if (leafletMap.current) {
      // supprimer anciens markers avant de recréer
      leafletMap.current.eachLayer((layer) => {
        if (layer instanceof L.Marker || layer instanceof L.Circle) {
          leafletMap.current.removeLayer(layer);
        }
      });

      // recréer la couche OSM
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
        leafletMap.current
      );

      items.forEach((item) => {
        const popup = `
              <div style="min-width: 250px; padding: 12px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
                <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 12px; border-radius: 8px 8px 0 0; margin: -12px -12px 12px -12px;">
                  <h3 style="margin: 0; font-size: 16px; font-weight: 600; display: flex; align-items: center; gap: 8px;">
                    <span style="font-size: 20px;">${item.riskType.icon || '⚠️'}</span>
                    ${item.title}
                  </h3>
                </div>
                
                <div style="background: #f8f9fa; padding: 10px; border-radius: 6px; margin-bottom: 10px;">
                  <div style="display: flex; align-items: center; gap: 6px; color: #495057; font-size: 13px; margin-bottom: 6px;">
                    <strong>Type de risque:</strong>
                  </div>
                  <div style="color: #6c757d; font-size: 12px; margin-left: 0px;">
                    ${item.riskType.description}
                  </div>
                </div>

                <div style="background: ${item.status === 'ALERT_ACTIVE' ? '#d4edda' :
            item.status === 'REJECTED' || item.status === 'DISMISSED' || item.status === 'RESOLVED' ? '#f8d7da' :
              '#cce5ff'
          }; padding: 8px; border-radius: 6px; border-left: 3px solid ${item.status === 'ALERT_ACTIVE' ? '#28a745' :
            item.status === 'REJECTED' || item.status === 'DISMISSED' || item.status === 'RESOLVED' ? '#dc3545' :
              '#007bff'
          };">
                  <div style="font-size: 11px; color: ${item.status === 'ALERT_ACTIVE' ? '#155724' :
            item.status === 'REJECTED' || item.status === 'DISMISSED' || item.status === 'RESOLVED' ? '#721c24' :
              '#004085'
          }; margin-bottom: 2px;">Statut</div>
                  <div style="font-size: 13px; font-weight: 600; color: ${item.status === 'ALERT_ACTIVE' ? '#155724' :
            item.status === 'REJECTED' || item.status === 'DISMISSED' || item.status === 'RESOLVED' ? '#721c24' :
              '#004085'
          };">${item.status}</div>
                </div>

                <div style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #e9ecef; font-size: 12px; color: #6c757d;">
                  📍 ${item.localities.type}: ${item.localities.name}<br/>
                  <span style="margin-left: 16px;">${item.localities.commune.name}, ${item.localities.commune.departement.name}</span>
                </div>
              </div>
            `;

        // Utiliser l'icône emoji si disponible, sinon l'icône par défaut
        const markerIcon = customIcon != null
          ? createEmojiIcon()
          : defaultIcon;

        L.marker(
          [item.localities.latitude, item.localities.longitude],
          { icon: markerIcon }
        ).addTo(leafletMap.current)
          .bindPopup(popup, { maxWidth: 320 });
      });
    }
  }, [items, modalAddOpen]);

  return (
    <>
      <Button style={{ float: "right" }} onClick={() => setModalAddOpen(true)}>
        <i aria-hidden="true">
          <FontAwesomeIcon icon={faMap} className="px-1" />
        </i>
      </Button>

      <Modal
        title=""
        style={{ top: 20 }}
        width={1000}
        open={modalAddOpen}
        maskClosable={false}
        closable={true}
        onCancel={() => setModalAddOpen(false)}
        footer={null}
      >
        <Spin spinning={loading}>
          <div style={{ height: "600px", width: "100%", borderRadius: '12px', overflow: 'hidden' }}>
            <div ref={mapRef} style={{ height: "600px" }}></div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}